import { TpAutoFormDef, promptAutoForm } from '../../../../components/auto-form-modal/AutoForm';
import { getUserError } from '../../../../components/miscUtils';
import { dbActionUserPromptTypeList, dbActionUserPromptTypeMap } from '../helpers/userPromptTypes';
import { createDbActionVar_Value } from '../helpers/variables';
import { TpDashboardActionContext, TpDbActionStepDefinition as TpDbActionStepTypeDefinition } from '../interfaces';

function getJsonSchema(): any {
  return {
    type: 'object',
    title: 'User Prompt',
    description:
      'Prompts the user in a modal form for a number of parameters. Each parameter is stored in a variable that can be referred to by "$VariableName"',
    properties: {
      type: { type: 'string', const: 'UserPrompt' },
      description: { type: 'string', description: 'Optional description of the prompt, added above all form fields.' },
      parameters: { type: 'array', items: { anyOf: dbActionUserPromptTypeList.map((type) => type.getJsonSchema()) } },
    },
    required: ['type'],
  };
}

function execute(ctx: TpDashboardActionContext, step: any, onCompleted: () => void) {
  const autoFormDef: TpAutoFormDef = {
    title: ctx.actionDef.name,
    description: step.description,
    fields: [],
  };

  for (const param of step.parameters) {
    const promptType = dbActionUserPromptTypeMap[param.type];
    if (!promptType) throw getUserError(`Invalid dasboard action parameter type: ${param.type}`);
    autoFormDef.fields.push(promptType.createAutoFormDef(ctx, param));
  }

  promptAutoForm(autoFormDef).then((data: any) => {
    for (const param of step.parameters) createDbActionVar_Value(ctx, param.id, data[param.id]);
    onCompleted();
  });
}

const dbActionStepTypeUserPrompt: TpDbActionStepTypeDefinition = {
  stepType: 'UserPrompt',
  execute,
  getJsonSchema,
};

export default dbActionStepTypeUserPrompt;
